/** @jsxImportSource @emotion/react */

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { FC } from "react";
import Section from "views/Mission/TeamSpecV2/components/Section";
import GenericModal from "views/Mission/TeamSpecV2/components/GenericModal";
import { css } from "@emotion/react";
import CardList from "views/HomeV2/CardList";
import { MissionSpecCard } from "models/MissionSpec";

const getCSSRules: CSSRulesResolver = ({ colors }) => ({
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: 16,
    borderTop: `1px solid ${colors.Grey[300]}`,
    gap: 16,
  },
  fade: {
    position: "absolute",
    width: "100%",
    left: 0,
    right: 0,
    height: 16,
    zIndex: 1,
  },
  fadeTop: {
    top: 44,
    background:
      "linear-gradient(0deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))",
  },
  fadeBottom: {
    bottom: 0,
    background:
      "linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
  },
  section: {
    marginTop: 24,
    padding: "0 16px",
    width: "auto",
  },
  body: {
    position: "relative",
    display: "flex",
    height: "auto",
    maxHeight: 800,
    overflowY: "auto",
    flexDirection: "column",
    gap: 16,
    overflowX: "hidden",
    width: "calc(100% - 2px)",
    padding: "16px 1px 16px 1px",
  },
});

const PastProjectsModal: FC<{
  isOpen: boolean;
  close: () => void;
  endedMissions: MissionSpecCard[];
}> = ({ close, isOpen, endedMissions }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={close}
      trackingName="Past Projects Modal"
      showGradient={false}
    >
      <Section name="Past projects" css={styles.section}>
        <div css={css(styles.fade, styles.fadeTop)} />
        <div css={styles.body}>
          {isOpen && endedMissions.length > 0 && (
            <CardList cards={endedMissions} />
          )}
        </div>
        <div css={css(styles.fade, styles.fadeBottom)} />
      </Section>
    </GenericModal>
  );
};

export default PastProjectsModal;
